import { render, staticRenderFns } from "./QueryDO.vue?vue&type=template&id=fc521d7a"
import script from "./QueryDO.vue?vue&type=script&lang=js"
export * from "./QueryDO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports